import { Button, Divider, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import Link from 'next/link'
import React from 'react'
import { format } from 'date-fns'

import { Post as IPost } from '../../../types/post'
import { urls } from '../../utils/config'

const useStyles = makeStyles((theme) => ({
  container: {
    margin: '20px auto',
    padding: '0 50px',
  },
  subcontainer: {
    margin: '40px auto',
    display: 'flex',
    zIndex: 100,
    flexDirection: 'column',
    maxWidth: '678px',
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
      padding: '20px',
    },
  },
  title: {
    fontFamily: 'Space Grotesk',
    fontWeight: 'bold',
    fontSize: '48px',
    letterSpacing: 0,
    [theme.breakpoints.down('md')]: {
      marginTop: '20px',
      textAlign: 'left',
    },
  },
  description: {
    fontFamily: 'Inter',
    fontSize: '16px',
    fontWeight: 400,
    marginTop: '15px',
  },
  podcastImage: {
    top: 0,
    width: 'auto',
    maxWidth: '100%',
    objectFit: 'cover',
    alignSelf: 'flex-start',
    margin: '20px auto',
    borderRadius: '12px',
    [theme.breakpoints.down('md')]: {
      margin: '20px auto',
      alignSelf: 'unset',
      height: 'auto',
    },
  },
  markdown: {
    fontFamily: 'Inter',
    margin: '20px 0',
    fontSize: '18px',
    color: '#2B1841',
    lineHeight: '32px',
    overflowWrap: 'break-word',
    '& img': {
      maxWidth: '100%',
    },
    '& a': {
      color: '#895DD1',
      fontWeight: 'bold',
    },
  },

  iframe: {
    '& iframe': {
      width: '100%',
      height: 'auto',
    },
  },
  sharingContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-end',
    '& h5': {
      color: '#895DD1',
      marginRight: '20px',
    },
  },
  readMore: {
    fontFamily: 'Inter',
    fontWeight: 500,
    fontSize: '14px',
    textDecoration: 'underline',
    '&:hover': {
      cursor: 'pointer',
      opacity: 0.8,
    },
  },
  date: {
    fontFamily: 'Inter',
    fontWeight: 'normal',
    fontSize: '14px',
    color: '#787878',
  },
}))

interface Props {
  post: IPost
}

function RelatedPost({ post }: Props): JSX.Element {
  const classes = useStyles({})

  return (
    <div className={classes.container}>
      <Divider />
      <div className={classes.subcontainer}>
        <Typography className={classes.date}>
          {format(new Date(post.createdAt), 'MMMM yyyy')}
        </Typography>
        <Typography variant="h3" className={classes.title}>
          {post.title}
        </Typography>
        <Typography className={classes.description}>{post.description}</Typography>
        <img
          width={680}
          height={300}
          src={post.type === 'podcast' ? `/podcast-banner.png` : post.banner?.url}
          className={classes.podcastImage}
          alt={`cryptotesters podcast image`}
        />
        <Link href={`${urls[post.type]}/${post.slug}`}>
          <div className={classes.readMore}>Read more</div>
        </Link>
      </div>
    </div>
  )
}

export default RelatedPost
